import {useMutation} from '@tanstack/react-query';
import {stageVoiceDraft} from '../host/voice-draft';
import type {TtsAssetResponse,PostTtsGenerateAsAssetRequestType} from '../../vendor/src/shared/apis/tts/post-tts-generate-as-asset';
export function useVoiceDraftStage(){
  return useMutation<{awaitingConfirmation:boolean;data:TtsAssetResponse|null},Error,PostTtsGenerateAsAssetRequestType&{from:number;fps:number}>({
    mutationFn:async body=>{
      if(!body.voice||!body.emotion)throw new Error('목소리와 감정을 선택해 주세요.');
      await stageVoiceDraft({text:body.text,voiceId:body.voice,speed:body.speedFactor??1,emotion:body.emotion,pitch:body.pitch,style:body.style,from:body.from,fps:body.fps});
      return {awaitingConfirmation:true,data:null};
    },
  });
}
